import { Button, Modal, ProgressBar, Table } from "react-bootstrap";
import { Loader2, CheckCircle } from "lucide-react";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { isMobile } from "react-device-detect";
import { OverlayTrigger } from "react-bootstrap";
import { Tooltip } from "react-bootstrap";

const ProgressModal = ({ show, importProgress, onClose }) => {
  const [progressMessage, setProgressMessage] = useState("Starting import...");
  const navigate = useNavigate();

  const progressMessages = [
    "Analyzing student data...",
    "Validating duplicates and errors...",
    "Processing batches...",
    "Almost done... Preparing summary...",
  ];

  useEffect(() => {
    if (!importProgress) return;

    const percent = (importProgress.processed_rows / importProgress.total_rows) * 100;

    if (percent < 25) setProgressMessage(progressMessages[0]);
    else if (percent < 50) setProgressMessage(progressMessages[1]);
    else if (percent < 85) setProgressMessage(progressMessages[2]);
    else if (percent < 100) setProgressMessage(progressMessages[3]);
    // else {
    //   setProgressMessage("✅ Import completed successfully!");
    //   setTimeout(() => {
    //     onClose();
    //     navigate("/get-student-import?navigate=true");
    //   }, 1500);
    // }
  }, [importProgress]);

  if (!show) return null;

  const percent = importProgress
    ? (importProgress.processed_rows / importProgress.total_rows) * 100
    : 0;

  const renderTooltip = (props) => (
    <Tooltip {...props}>
        <p className="fw-bold">It’s safe to close this window — your import will keep running in the background</p>
    </Tooltip>
  );

  return (
    <Modal 
        show={show} 
        centered 
        size="lg"
        // backdrop="static" 
        // keyboard={false}
        // onHide={onClose}
    >
        <Modal.Header>
            <Modal.Title className="d-flex gap-3 w-100 justify-content-between align-items-center">
            Import In-progress
            </Modal.Title>
            <OverlayTrigger
                placement="bottom"
                overlay={renderTooltip}
                delay={{ show: 100, hide: 200 }}
            >
                <Button size="sm" onClick={onClose} className="w-25">Run in background</Button>
            </OverlayTrigger>
        </Modal.Header>
        <Modal.Body style={{ maxHeight: isMobile ? "70vh":"85vh", overflowY: "auto" }}>
            <div className="p-4 text-center">
                {importProgress && importProgress.processed_rows === importProgress.total_rows ? (
                <CheckCircle size={50} className="text-success mb-3" />
                ) : (
                <Loader2 size={50} className="text-primary mb-3 spin" />
                )}

                <h5 className="fw-bold text-dark mb-2">{progressMessage}</h5>

                {importProgress && (
                <>
                    <ProgressBar
                    now={percent}
                    animated
                    striped
                    variant={percent === 100 ? "success" : "info"}
                    style={{ height: "20px", borderRadius: "10px" }}
                    />
                    <small className="text-muted d-block mt-2">{Math.floor(percent)}% completed</small>

                    <div>
                        <h6 className="text-start mb-0 mt-1 "><strong>Overall Progress.</strong></h6>
                        <div className="d-flex gap-5 text-start mt-2 mb-3">
                            <p className="mb-1">
                            <strong>Total:</strong> {importProgress.total_rows}
                            </p>
                            <p className="mb-1 text-success">
                            <strong>Success:</strong> {importProgress.success_count}
                            </p>
                            <p className="mb-1 text-warning">
                            <strong>Duplicates:</strong> {importProgress.duplicate_count}
                            </p>
                            <p className="mb-1 text-danger">
                            <strong>Failed:</strong> {importProgress.error_count}
                            </p>
                        </div>
                    </div>

                    {importProgress.batch_logs && importProgress.batch_logs.length > 0 && (
                    <div className="mt-3 text-start">
                        <h6 className="fw-bold mb-2">Batch wise Details</h6>
                        <Table size="sm" bordered>
                        <thead className="table-light">
                            <tr>
                            <th>Batch</th>
                            <th>Rows in Batch</th>
                            <th>Success</th>
                            <th>Duplicates</th>
                            <th>Errors</th>
                            </tr>
                        </thead>
                        <tbody>
                            {importProgress.batch_logs.map((batch) => (
                            <tr key={batch.batch_number}>
                                <td>{batch.batch_number}</td>
                                <td>{batch.rows_in_batch}</td>
                                <td className="text-success">{batch.success}</td>
                                <td className="text-warning">{batch.duplicates}</td>
                                <td className="text-danger">{batch.errors}</td>
                            </tr>
                            ))}
                        </tbody>
                        </Table>
                    </div>
                    )}
                    <p className="fw-bold">It’s safe to close this window — your import will keep running in the background</p>
                </>
                )}
            </div>
        </Modal.Body>
      <style>
        {`
          .spin {
            animation: spin 1.2s linear infinite;
          }
          @keyframes spin {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}
      </style>
    </Modal>
  );
};

export default ProgressModal;
